module.exports = __webpack_public_path__ + "img/bd639f4.png";